import { HStack } from '@pets-ui/HStack/HStack'
import { Image } from '@pets-ui/Image/Image'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { formatPrice } from '@utils'

export interface AddonProductInfoProps {
  thumbnail?: string
  title?: string
  currency?: string
  salePrices: number[]
  selectedSalePrice?: number
}

export const AddonProductInfo = (props: AddonProductInfoProps) => {
  const { thumbnail, title, currency, salePrices, selectedSalePrice } = props

  const renderPrice = () => {
    if (salePrices.length > 1) {
      return formatPrice(currency, selectedSalePrice)
    }
    if (salePrices.length > 1) {
      return `${formatPrice(currency, Math.min(...salePrices))}-${formatPrice(currency, Math.max(...salePrices))}`
    }
    if (salePrices.length === 1) {
      return formatPrice(currency, salePrices[0])
    }
    return ''
  }
  return (
    <HStack gap={3}>
      <Image src={thumbnail} alt={title} width={100} height={100} />
      <VStack justifyContent="space-between" pr={10}>
        <Text>{title}</Text>
        <Text color={colors.brand} variant="subtitle">{renderPrice()}</Text>
      </VStack>
    </HStack>
  )
}
